import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class PermissionService {
  constructor(private http: HttpClient) {
  }

  sidebarPermissions() {
    return this.http.get<any>(`${environment.apiUrl}/sidebar-permissions`);
  }

  canAccessRoute(route) {
    // encodeURIComponent so route names containing &, ?, # or spaces don't collide with URL syntax.
    return this.http.get<any>(`${environment.apiUrl}/can-access?route=` + encodeURIComponent(route));
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
  }

  canAccessFunctionality(fnc) {
    // JS-1920 (2026-10-17): encodeURIComponent is required — the new "Delete & Cancel Self
    // Service Project" permission contains '&', which otherwise gets parsed as a second query
    // param on the server (functionality=Delete + a separate "Cancel Self Service Project" key).
    return this.http.get<any>(`${environment.apiUrl}/can-access-functionality?functionality=` + encodeURIComponent(fnc));
  }

  // JS-1920 (Phase 4 2026-10-16, Phase 5 2026-10-17): module-level self-service check — true
  // if the user holds any of the 6 granular self-service perms (Create / View All / View Own /
  // Edit All / Edit Own / Delete). After Phase 5 the legacy "Self Service" row is deleted, so
  // this is now the only self-service module check available.
  canAccessSelfServiceModule() {
    return this.http.get<any>(`${environment.apiUrl}/can-access-self-service-module`);
  }
}
